module.exports = __webpack_public_path__ + "chatgpt.svg?3d10d368cc270b4c6e89fa78c1798263";